import type { OnboardingCopy, OnboardingFormValues } from '@/pages/onboarding/onboarding.types';

const joinParts = (parts: (string | null | undefined)[]) => parts.filter(Boolean).join(' · ');

/** "Starf" row text, including the specialty for doctors. */
export const professionSummary = (values: OnboardingFormValues, copy: OnboardingCopy): string => {
  const { profession, professionOther, specialty, specialtyOther } = values;
  if (!profession) return '';
  if (profession === 'other') return professionOther.trim() || copy.profession.options.other;
  if (profession !== 'doctor' || !specialty) return copy.profession.options[profession];
  const specialtyLabel = specialty === 'other' ? specialtyOther.trim() : copy.profession.specialties[specialty];
  return joinParts([copy.profession.options.doctor, specialtyLabel]);
};

export const consultationsSummary = (values: OnboardingFormValues, copy: OnboardingCopy): string =>
  values.consultationTypes.map((type) => copy.work.consultationTypes[type]).join(', ');

export const modeSummary = (values: OnboardingFormValues, copy: OnboardingCopy): string =>
  values.sessionMode ? copy.work.modes[values.sessionMode].label : '';

export const detailSummary = (values: OnboardingFormValues, copy: OnboardingCopy): string =>
  joinParts([copy.detail.levels[values.noteDetail], copy.detail.formats[values.noteFormat]]);

/** The person's job title from their answers, e.g. "heimilislæknir"; a free-text profession as typed. */
const signatureTitle = (values: OnboardingFormValues, copy: OnboardingCopy): string => {
  const { profession, professionOther, specialty } = values;
  if (!profession) return '';
  if (profession === 'other') return professionOther.trim();
  if (profession === 'doctor' && specialty) return copy.summary.signatureTitles.specialties[specialty];
  return copy.summary.signatureTitles.professions[profession];
};

/** "Nafn, starfsheiti" from the answers, leaving out whatever is not known. */
export const suggestedSignature = (values: OnboardingFormValues, copy: OnboardingCopy, name?: string): string =>
  [name?.trim(), signatureTitle(values, copy)].filter(Boolean).join(', ');
